<script>
import bem from '@/utils/bem';
import { mapActions } from 'vuex';

const b = bem('user-address-form');
export default {
  data() {
    return {
      formState: {
        apartment: '',
        city: '',
        companyName: '',
        firstName: '',
        lastName: '',
        notes: '',
        phone: '',
        state: {
          label: 'Select state',
          value: null,
        },
        streetAddress: '',
        zipCode: '',
      },
      mounted: false,
    };
  },
  watch: {
    addressInfo: {
      handler(newValue, oldValue) {
        if (Object.keys(oldValue).length === 0 && newValue && Object.keys(newValue).length !== 0) {
          this.formState = newValue;
          if (!this.formState.email && this.userEmail) {
            this.formState.email = this.userEmail;
          }
        }
        if (!this.mounted) {
          this.mounted = true;
        }
      },
    },
  },
  props: {
    isBilling: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    states: {
      type: Array,
      required: true,
    },
    addressInfo: {
      type: Object,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
    isCompanyUser: {
      type: Boolean,
      default: false,
    },
    userEmail: {
      type: String,
      default: '',
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      saveUserInfoAction: 'users/saveUserAddressInfo',
    }),
    onSave(value) {
      this.saveUserInfoAction({
        ...value,
        ...(this.isCompanyUser ? { email: this.userEmail } : {}),
        country: 'USA',
        userId: this.userId,
        isBilling: this.isBilling,
      });
      if (this.isCompanyUser) {
        this.saveUserInfoAction({
          ...value,
          country: 'USA',
          userId: this.userId,
          isBilling: false,
        });
      }
    },
  },
};
</script>

<template>
  <div :class="b('')" v-if="mounted">
    <FormKit
        type="form"
        submit-label="Save"
        @submit="onSave"
    >
      <h1 class="text-2xl font-bold mb-2">{{title}}</h1>
      <div :class="b('row')">
        <div :class="b('input')">
          <FormKit
              type="text"
              name="firstName"
              label="First name"
              placeholder="First name"
              :value="formState.firstName"
              validation="required"
          />
        </div>
        <div :class="b('input')">
          <FormKit
              type="text"
              name="lastName"
              label="Last name"
              :value="formState.lastName"
              placeholder="Last name"
              validation="required"
          />
        </div>
      </div>
      <div :class="b('row')" v-if="!isCompanyUser">
        <div :class="b('input')" v-if="isBilling">
          <FormKit
              type="text"
              name="email"
              label="Email"
              :value="formState.email"
              placeholder="Email"
              validation="required|email"
          />
        </div>
        <div :class="b('input',{ full: !isBilling })">
          <FormKit
              type="text"
              name="companyName"
              :value="formState.companyName"
              label="Company name"
              placeholder="Company name"
          />
        </div>
      </div>
      <div :class="b('row')">
        <div :class="b('input', { full: isCompanyUser })">
          <FormKit
              type="text"
              name="streetAddress"
              :value="formState.streetAddress"
              label="Street address"
              placeholder="Street address"
          />
        </div>
        <div :class="b('input')" v-if="!isCompanyUser">
          <FormKit
              type="text"
              name="apartment"
              :value="formState.apartment"
              label="Apartment"
              placeholder="Apartment"
          />
        </div>
      </div>
      <div :class="b('row')">
        <div :class="b('input')">
          <FormKit
              type="text"
              name="city"
              :value="formState.city"
              label="City"
              placeholder="City"
          />
        </div>
        <div :class="b('input')">
          <FormKit
              type="select"
              label="State"
              placeholder="State"
              name="state"
              :value="formState.state"
              :options="states"
              validation="required"
          />
        </div>
      </div>
      <div :class="b('row')">
        <div :class="b('input')">
          <FormKit
              type="text"
              name="zipCode"
              :value="formState.zipCode"
              label="Zipcode"
              placeholder="Zipcode"
              validation="required|minlength:5|matches:/[1-9]/"
              :validation-messages="{
               matches: 'Please include at least 5 symbol',
             }"
          />
        </div>
        <div :class="b('input')">
          <FormKit
              type="tel"
              name="phone"
              :value="formState.phone"
              label="Phone number"
              placeholder="+1xxxxxxxxxx"
              validation="required|matches:/^\+[1-9][0-9]{10}$/"
              :validation-messages="{
                matches: 'Phone number must be in the format +1xxxxxxxxxx',
              }"
          />
        </div>
      </div>
      <div :class="b('row')" v-if="!isBilling && !isCompanyUser">
        <div :class="b('input', { full: true })">
          <FormKit
              type="textarea"
              name="notes"
              :value="formState.notes"
              label="Notes"
              placeholder="Notes"
          />
        </div>
      </div>
    </FormKit>
  </div>
</template>

<style scoped lang="scss">
.user-address-form {
  width: 400px;

  &__row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: flex-start;
  }

  &__input {
    width: 45%;

    &_full {
      width: 100%;
    }
  }
}
</style>
